module.exports = __webpack_public_path__ + "media/images/application/icons/icon-bookmark-7d9e184a2c5c2b4da0fc376198f3bd16.svg";